import { render, staticRenderFns } from "./listMCOnboard.vue?vue&type=template&id=1ef97bcb&scoped=true"
import script from "./listMCOnboard.vue?vue&type=script&lang=js"
export * from "./listMCOnboard.vue?vue&type=script&lang=js"
import style0 from "./listMCOnboard.vue?vue&type=style&index=0&id=1ef97bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef97bcb",
  null
  
)

export default component.exports